import { useServicePrimaryTagListQuery } from "entities/tagTypes/queries/useServicePrimaryTagListQuery";
import { useTagsListQuery } from "entities/tags/queries/useTagsListQuery";
import { Tag } from "entities/tags/types";
import groupBy from "lodash/groupBy";
import { useMemo } from "react";
import { PrimaryTag } from "widgets/ModuleTagsWidget/type";
import { GameTagBlock } from "../../../stores/useGameTagsData";

type Props = {
  id: string;
  primaryTagId: string | null;
  tagBlocks: GameTagBlock[];
};

// It's a copy of useServiceTagsOptions from ModuleTagsWidget
// Refactor later to use the same hook for both modules
export const useServiceTagsOptions = ({
  id,
  primaryTagId,
  tagBlocks,
}: Props) => {
  const { data: servicePrimaryTags } = useServicePrimaryTagListQuery();
  const { data: serviceTags = [] } = useTagsListQuery();

  const groupedRawServiceTags: Record<PrimaryTag, Tag[]> = useMemo(
    () => groupBy(serviceTags, "tagType"),
    [serviceTags],
  );

  const secondaryServiceTags = useMemo(() => {
    if (primaryTagId) {
      return (
        groupedRawServiceTags[primaryTagId]?.map((tag) => ({
          id: tag.id,
          name: tag.name,
        })) ?? []
      );
    }

    return [];
  }, [groupedRawServiceTags, primaryTagId]);

  const servicePrimaryTagOptions =
    servicePrimaryTags
      ?.filter((primaryTag) => {
        const isAlreadySelected = tagBlocks.some(
          (block) => block.id !== id && block.primaryTagId === primaryTag.id,
        );

        return !isAlreadySelected;
      })
      ?.map((primaryTag) => ({
        value: primaryTag.id,
        label: primaryTag.name,
      })) ?? [];

  return {
    secondaryServiceTags,
    servicePrimaryTagOptions,
  };
};
